import {ErrorMessagesForPaymentMethodInput, MobileCarrierInfo, MobileCarrierKey} from '../../../../Props/ContractInputInfo'
import React, {useCallback} from 'react'
import {Spacer} from '../../../../../Common/Components/Spacer'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {MBMemberRadio} from '../../../Atoms/MBMemberRadio'
import {PIMWarningMessages} from '../../../Atoms/Labels/PIMWarningMessages'

export type ErrorMessageForMobileCarrierInput =
  Pick<ErrorMessagesForPaymentMethodInput, 'mobileCarrierErrors'>

type MobileCarrierInputComponentForProps = {
  mobileCarrierInputInfo: MobileCarrierInfo
  errorMessage: ErrorMessageForMobileCarrierInput
  onChangeInputDetailInfo: (changeInputDetailInfo: MobileCarrierInfo) => void
}
type MobileCarrierInfoListItem = { name: string, carrierKey: MobileCarrierKey }
const mobileCarrierInfoList: MobileCarrierInfoListItem[] = [
  {
    name: 'docomo',
    carrierKey: 'docomo'
  },
  {
    name: 'softbank',
    carrierKey: 'softbank'
  },
  {
    name: 'au',
    carrierKey: 'au'
  }
]


export const MobileCarrierInputComponent: React.VFC<MobileCarrierInputComponentForProps> =
  (props) => {
    const mobileCarrierInfoState = props.mobileCarrierInputInfo
      || {
        carrierKey: '',
      } as MobileCarrierInfo

    const updateMobileCarrierInfo = useCallback((
      value: MobileCarrierKey, mobileCarrierInfo: MobileCarrierInfo,
    ): MobileCarrierInfo => {
      return {
        ...mobileCarrierInfo,
        carrierKey: value,
      }
    }, [])

    return (
      <Spacer ml={'10%'} dataTestId={'block-input-mobile-carrier-information'}>
        <Spacer mt={'18px'}>
          <PIMStack spacing={'10px'}>
            <div>決済キャリア</div>

            {mobileCarrierInfoList.map((mobileCarrierInfo) => {
              return (
                <MBMemberRadio
                  key={mobileCarrierInfo.carrierKey}
                  labelName={mobileCarrierInfo.name}
                  value={mobileCarrierInfo.carrierKey}
                  hasError={props.errorMessage.mobileCarrierErrors.length > 0}
                  onChange={(): void => {
                    props.onChangeInputDetailInfo(
                      updateMobileCarrierInfo(mobileCarrierInfo.carrierKey as
                        MobileCarrierKey, mobileCarrierInfoState),
                    )
                  }}
                  checked={props.mobileCarrierInputInfo.carrierKey === mobileCarrierInfo.carrierKey}
                />
              )
            })}

            {props.errorMessage.mobileCarrierErrors.length > 0 && (
              <PIMWarningMessages messages={props.errorMessage.mobileCarrierErrors}/>
            )}
          </PIMStack>
        </Spacer>
      </Spacer>
    )
  }
